export class CreateIssueViewModel {
    public id: number;
    public callReferenceId: string = '';
    public customerId: string = '';
    public issueType: string = '';
    public issueCategory: string = '';
    public notes: string = '';
    public contactName: string = '';
    public originator: string = 'Agent';
    public clientName: string = '';
    constructor(inCallReferenceId: string | null, inCustomerId: string | null, inClientName: string | null) {
        this.callReferenceId = inCallReferenceId ?? "";
        this.customerId = inCustomerId ?? "";
        this.clientName = inClientName ?? "";
    }
}